<template>
  <div align="left" class="brief">
    <Header :hasBack="goback" :hasRight="false">
    </Header>
    <div style="padding: 0 60px; flex: 1; width: 1170px; margin: auto">
      <h2 align="center" style="margin-top: 0">Download</h2>
      <p>Welcome:Kssd client support for Windows 64bit OS.</p>
      <p>
        <a :href="downloadInstall" download="">
          <i
            class="el-icon-download"
            style="font-size: 24px; cursor: pointer"
            title="downloadInstall"
            >Download</i
          >
        </a>
      </p>
    </div>

    <Footer style="width: 1170px; margin: auto" />
  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'
export default {
  name: 'downloadInstall',
  data () {
    return {
      goback: true,
      downloadInstall: ''
    }
  },
  components: { Footer, Header },
  mounted () {
    if (this.$route.query.goback !== undefined) {
      this.goback = this.$route.query.goback === 1
    }
    console.log('query.goback:', this.$route.query.goback)
    console.log('this.goback:', this.goback)
    this.downloadInstall = this.cloudUrl + '/downloadInstall'
  },
  methods: {
  }
}
</script>

<style scoped>
.brief {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/downloadInstall.vue